import React from "react";
import { IconButton } from "@mui/material";

const PaginationButton = ({ icon, onClick, disabled, hidden = false }) => {
    const visibilityParam = hidden ? { sx: { visibility: "hidden" } } : {};
    return <IconButton {...visibilityParam} disabled={disabled} onClick={onClick}>{icon}</IconButton>
}

export default PaginationButton;
